// Lightweight anonymous analytics client for TimeCapsule 24.
// No cookies — one random session id stored in localStorage.
import { API } from "./api";

const KEY = "tc24_session_id";

function getSessionId() {
  try {
    let sid = localStorage.getItem(KEY);
    if (!sid) {
      sid = (typeof crypto !== "undefined" && crypto.randomUUID)
        ? crypto.randomUUID()
        : `s_${Date.now()}_${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(KEY, sid);
    }
    return sid;
  } catch {
    return "anon";
  }
}

export function trackEvent(event, props = {}) {
  if (!event) return;
  const payload = {
    event,
    session_id: getSessionId(),
    props,
    path: typeof window !== "undefined" ? window.location.pathname : "",
    referrer: typeof document !== "undefined" ? document.referrer : "",
  };
  // fire-and-forget; use keepalive so it survives page navigations
  try {
    fetch(`${API}/events`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* noop */
  }
}
